import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setOfficeCommentData } from "../../redux/office";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { FormTextField } from "../FormTextField/FormTextField";
import { ListItem } from "@mui/material";

export const OfficeDescriptionForm = (props) => {
  const dispatch = useDispatch();
  const { description, service_uuid } = props;

  const defaultValues = {
    description: description
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string().test("is_max", "Maximum of 64 characters", (val, values) => val?.length <= 64)
  });

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    reValidateMode: "onChange",
    mode: "onSubmit",
    shouldFocusError: true,
    defaultValues: {
      ...defaultValues
    }
  });

  const {
    watch,
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitted, isSubmitSuccessful }
  } = methods;

  useEffect(() => {
    reset({ ...defaultValues });
  }, [description]);

  const onSubmit = (data) => {
    // console.log("data", data);
    const finalData = {
      service_uuid: service_uuid,
      data: { description_comment: data?.description }
    };
    dispatch(setOfficeCommentData(finalData));
  };

  return (
    <>
      <FormProvider {...methods}>
        <div className="office_form_field_wrapper">
          <FormTextField
            type="text"
            isVisible={true}
            fieldLabel={"Description"}
            fieldName={"description"}
            maxLength={64}
            isMulti={true}
            isDisabled={false}
            isCountChar={true}
            isOfficeCard={true}
            callbackOfficeCard={handleSubmit(onSubmit)}
          />
        </div>
      </FormProvider>
    </>
  );
};
